import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import Layout from "../utils/core/Layout";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { resetPasswordAction } from "../../redux/actions/authentication/authenticationAction";

export const ResetPassword = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  const password = useRef({});
  password.current = watch("password", "");

  let { id } = useParams();
  let { uid } = useParams();

  const navigate = useNavigate();

  const onSubmit = (data, event) => {
    event.preventDefault();
    if (Object.keys(errors).length === 0) {
      props.resetPassword(uid, id, data, navigate);
    }
  };

  return (
    <Layout>
      <div className="login-page">
        <main>
          <section className="login-area">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="inner-content">
                    <h2>
                      Welcome to <br></br>a new era
                    </h2>
                    <p>
                      Intro to the log in / sign up if required. Intro to the
                      log in / sign up if required. Intro to the log in / sign
                      up if required.{" "}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 text-center">
                  <div className="login-form">
                    <h5>Reset Password</h5>
                    {/* {this.state.errorUsername && (
                                                <p style={{color: "red", fontSize:'14px',}}>{this.state.errorUsername}</p>
                                            )} */}
                    {/* {this.state.errorEmail && (
                                                    <p style={{color: "red", fontSize:'14px',}}>{this.state.errorEmail}</p>
                                                )} */}
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-group table-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          placeholder="Password"
                          name="password"
                          autoComplete="off"
                          {...register("password", {
                            required: "Password is Required",
                            minLength: {
                              value: 8,
                              message:
                                "Password must have at least 8 characters",
                            },
                            pattern: {
                              value: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(.*\W.*)/g,
                              message:
                                "Please Enter a one lower, one upper, one digit and one special character",
                            },
                            // pattern: { value: /[A-Z]/g, message: "Please Enter a upper character" },
                            // pattern: { value: /[0-9]/g, message: "Please Enter atleast one digit" },
                          })}
                        />
                        <div className="input-group-append">
                          <button
                            onClick={() => setShowPassword(!showPassword)}
                            className="btn btn-outline-secondary"
                            type="button"
                          >
                            Show
                          </button>
                        </div>
                      </div>
                      <p style={{ color: "red", fontSize: "14px" }}>
                        {errors.password?.message}
                      </p>
                      <div className="input-group table-group">
                        <input
                          type={showConfirmPwd ? "text" : "password"}
                          className="form-control"
                          id="confirmpassword"
                          placeholder="Confirm Password"
                          name="confirmpassword"
                          autoComplete="off"
                          {...register("confirmPassword", {
                            required: "Confirm Password is Required",
                            validate: (value) =>
                              value === password.current ||
                              "The passwords do not match",
                          })}
                        />
                        <div className="input-group-append">
                          <button
                            onClick={() => setShowConfirmPwd(!showConfirmPwd)}
                            className="btn btn-outline-secondary"
                            type="button"
                          >
                            Show
                          </button>
                        </div>
                      </div>
                      <p style={{ color: "red", fontSize: "14px" }}>
                        {errors.confirmPassword?.message}
                      </p>

                      <div className="login-linkedin">
                        <button type="submit" className="btn btn-secondary">
                          Submit
                        </button>
                      </div>
                    </form>
                    <div className="inner-content">
                      <p>
                        Intro to the log in / sign up if required. Intro to the
                        log in / sign up if required. Intro to the log in / sign
                        up if required.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="img-list d-none d-md-block">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img2.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img3.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img4.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img5.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img6.png"
                      alt="neet"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const signUpError = state.authentication.forgetPassword;
  const is_user = state.user.is_user;

  return {
    signUpError: signUpError,
    is_user: is_user,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    resetPassword: (uid, id, data, navigate) =>
      dispatch(resetPasswordAction(uid, id, data, navigate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
